import { render, staticRenderFns } from "./PublicHeaderComponent.vue?vue&type=template&id=65faedfa&scoped=true&"
import script from "./PublicHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./PublicHeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./PublicHeaderComponent.vue?vue&type=style&index=0&id=65faedfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65faedfa",
  null
  
)

export default component.exports